export const borderWidths = {
  none: '0',
  s: '1px',
  m: '2px',
  l: '3px',
};

export const outlines = {
  outlineFocus: '{{ borderWidths.m }} solid {{ borderColors.borderFocus }}',
  outlineInputFocus: '{{ borderWidths.s }} solid {{ borderColors.borderFocus }}',
  outlineFocusHighEmphasis: '{{ borderWidths.m }} solid {{ borderColors.borderFocusHighEmphasis }}',
  outlineFocusMultipleBackgrounds: '{{ borderWidths.m }} solid {{ borderColors.borderFocusMultipleBackgrounds }}',
};

export const radii = {
  none: '0',
  xs: '{{ GRID }}px',
  s: '{{ GRID * 2 }}px',
  m: '{{ GRID * 4 }}px',
  l: '{{ GRID * 6 }}px',
  xl: '{{ GRID * 8 }}px',
  round: '9999px',
};
